/*
 * @Author: shiao
 * @Date: 2021-01-07 14:11:42
 * @LastEditTime: 2021-01-30 17:49:52
 * @Description: 
 * @LastEditors: shiao
 * @FilePath: \o2o-appd:\gongsi\h5-hotel\h5\src\pages\hotel\api\index.js
 */
import axios from '@/providers/http.js'

/************************************首页***************************************/
let getAdvData = () => {//获取首页广告信息
    return axios.post('/adspace/index/get/ad/list',{labels:['shallBuy_HotelV2_index_banner']})
}
let getCityCode = (obj) => {
    return axios.post('/hotelv2/index/hotel/get/city/code',obj);
}
let getHotCityData = () => {//获取热门城市信息
    return axios.post('/hotelv2/index/city/list');
}
let getHotAroundData = (city_code=1) => {//获取附件热门地点
    return axios.post('/hotelv2/index/peripheral',{city_code:city_code});
}
let getFilterData = (city_code) => {//获取筛选条件参数
    return axios.post('/hotelv2/index/search/condition', { city_code: city_code })
}
let getHotelListData = (obj) => {//获取筛选结果列表
    return axios.post('/hotelv2/index/getList', obj)
}

const getHotelSearchCity = (city_name) => {//根据城市名称搜索城市
    return axios.post('/hotelv2/index/hotel/search/city', {city_name:city_name})
}

//高德地图坐标转换定位
const restapiLongitudeLatitude=(LatitudeAndLongitude)=>{
    return axios.get(`https://restapi.amap.com/v3/geocode/regeo?location=${LatitudeAndLongitude.longitude},${LatitudeAndLongitude.latitude}&key=a449a004e395c556758825af547fc90d&radius=1000&extensions=all`,{notoken:'notoken'})
}

/************************************详情***************************************/
const getHotelDetail = (hotel_id,longitude,latitude) => {//获取酒店详情
    return axios.post('/hotelv2/member/hotel/detail', { hotel_id: hotel_id,longitude:longitude,latitude:latitude })
}
const getHotelRoom = (hotel_id,start_time,end_time) => {//获取酒店房间
    return axios.post('/hotelv2/member/hotel/room', { hotel_id: hotel_id,start_time:start_time,end_time:end_time })
}
const getHotelGuess = (hotel_id,longitude,latitude) => {//获取酒店猜你喜欢
    return axios.post('/hotelv2/member/hotel/guess', { hotel_id: hotel_id,longitude:longitude,latitude:latitude })
}

const getHotelCheckRoom = (hotel_id,start_time,end_time,room_id,people_num,room_num,short_name,late_arrival_time) => {//检查房间是否可定
    return axios.post('/hotelv2/member/hotel/checkRoom', { hotel_id: hotel_id,start_time:start_time,end_time:end_time,room_id:room_id,
        people_num:people_num,room_num:room_num,short_name:short_name,late_arrival_time:late_arrival_time })
}

const hotelAddCollection= (hotel_id) => {//酒店收藏
    return axios.post('/hotelv2/member/hotel/addCollection', { hotel_id: hotel_id })
}

const hotelCancelCollection= (hotel_id) => {//酒店取消收藏
    return axios.post('/hotelv2/member/hotel/cancelCollection', { hotel_id: hotel_id })
}
const GethotelPlatforminfo= () => {//获取酒店详细信息
    return axios.post('/hotelv2/index/platform/info', { short_name: 'CTrip' })
}

const hotelTaxisPrice= (longitude,latitude,to_longitude,to_latitude) => {//酒店的打车价格
    return axios.post('/hotelv2/member/hotel/car/price', { longitude:longitude,latitude:latitude,to_longitude:to_longitude,to_latitude:to_latitude })
}


/************************************详情分享，只需要hotel_id***************************************/

const getShareHotelDetail = (hotel_id) => {//获取酒店详情
    return axios.post('/hotelv2/index/hotel/detail', { hotel_id: hotel_id })
}
const getShareHotelRoom = (hotel_id,start_time,end_time) => {//获取酒店房间
    return axios.post('/hotelv2/index/hotel/room', { hotel_id: hotel_id ,start_time:start_time,end_time:end_time})
}
const getShareHotelGuess = (hotel_id) => {//获取酒店猜你喜欢
    return axios.post('/hotelv2/index/hotel/guess', { hotel_id: hotel_id })
}
/************************************订单***************************************/
let getOrderconfirmData=(parame)=>{
    return axios.post('/order/member/order/confirm',parame)
}
let getPayment=(parame)=>{
    return axios.post('/hotelv2/member/order/pay-validate',parame)
}
let createOrderData=(params)=>{
    return axios.post('order/member/order/create',params)
}

/************************************首页***************************************/
/************************************详情***************************************/
/************************************订单***************************************/
let getOrderList = (params) => {
    return axios.post('/hotelv2/member/order/list',params
    )
}
let getGuessOrderList = (params) => {
    return axios.post('/hotelv2/member/hotel/guess',params
    )
}
let getOrderDetail = (params) => {
    return axios.post('/hotelv2/member/order/detail',params
    )
}
let getCancel = (params) => {
    return axios.post('/hotelv2/member/order/cancel',params
    )
}
let getCredits = (params) => {
    return axios.post('/hotelv2/member/order/getCredits',params
    )
}
let sendLetter = (params) => {
    return axios.post('/hotelv2/member/push/msgConfirm',params
    )
}
let delOrder = (params) => {
    return axios.post('/hotelv2/member/order/delete',params
    )
}

/************************************官方图片***************************************/
let getOfficialimgData=(params)=>{
    return axios.post('/hotelv2/member/hotel/detail',params)
}
/************************************收藏***************************************/
let getCollectionLabel = () => {//获取收藏城市列表
    return axios.get('/hotelv2/member/hotel/collection/label');
}

let getCollectionData = (obj) => {//获取收藏信息
    return axios.post('/hotelv2/member/hotel/collectionList',obj)
}

export{
    getAdvData,
    getCityCode,
    getHotCityData,
    getHotAroundData,
    getOrderconfirmData,
    getPayment,
    createOrderData,
    getOfficialimgData,
    getFilterData,
    getHotelDetail,
    getHotelRoom,
    getHotelListData,
    getCollectionData,
    getCancel,
    getCredits,
    sendLetter,
    delOrder,
    getOrderDetail,
    getOrderList,
    getGuessOrderList,
    getHotelGuess,
    getHotelCheckRoom,
    getCollectionLabel,
    hotelAddCollection,
    hotelCancelCollection,
    hotelTaxisPrice,
    GethotelPlatforminfo,
    getShareHotelDetail,
    getShareHotelRoom,
    getShareHotelGuess,
    getHotelSearchCity,
    restapiLongitudeLatitude
}
